const endpoints = {
    /* ================= AUTH ================= */
    auth: {
        login: "/superadmin/login/",
        logout: "/superadmin/logout/",
        forgotPassword: "/consultant/consultant-forget-password-reset-link/forgot-password/",
        resetPasswordConfirm: "/consultant/consultant-forget-password-reset-link/reset-password/confirm/",
    },

    /* ================= Dashboards ================= */
    Dashboard: {
        superadmindata: "/superadmin/dashboard/",
        consultantdata: "/consultant/dashboard/data/",
    },

    consultant: {
        profile: "/consultant/profile/",
        profileStatusUpdate: "/consultant/consultant-complete-profile/complete-profile-setup/",
    },

    /* ================= LOCATION ================= */
    location: {
        countryList: "/users/country-list/",
        stateList: "/users/state-list/",
        cityList: "/users/city-list/",
    },

    /* ================= ORGANIZATIONS ================= */
    organization: {
        list: "/superadmin/organization/",
        summary: "/superadmin/organization-summery/",
        create: "/superadmin/organization/",
        update: (id) => `/superadmin/organization/${id}/`,
        detail: (id) => `/superadmin/organization-detail/${id}/`,
        toggleStatus: (id) => `/superadmin/organization/${id}/activate-deactivate/`,
        customers: (id) => `/superadmin/organization/customers/${id}/`,
        industryList: "/superadmin/industry-list/",
    },

    /* ================= CUSTOMERS ================= */
    customer: {
        list: "/superadmin/customer/",
        count: "/superadmin/customer-count/",
        detail: (id) => `/superadmin/customer/${id}/`,
        create: "/superadmin/customer/",
        update: (id) => `/superadmin/customer/${id}/`,
        suspendAccount: (id) => `/superadmin/suspend-account/${id}/`,
        organizationList: "/superadmin/organization-list/",
        programManagerList: "/superadmin/program-manager-list/",
        assignManager: (id) => `/superadmin/assign-manager/${id}/`,
    },

    /* ================= BUSINESS USERS ================= */
    businessUser: {
        list: "/superadmin/business-user/",
        count: "/superadmin/business-user-count/",
        create: "/superadmin/business-user/",
        update: (id) => `/superadmin/business-user/${id}/`,
        detail: (id) => `/superadmin/business-user/${id}/`,
        suspendAccess: (id) => `/superadmin/suspend-access/${id}/`,
        roleList: "/superadmin/role-list/",
        organizationList: "/superadmin/organization-list/",
    },

    /* ================= PROGRAM MANAGERS ================= */
    programManager: {
        list: "/superadmin/program-manager/",
        count: "/superadmin/program-manager-count/",
        create: "/superadmin/program-manager/",
        update: (id) => `/superadmin/program-manager/${id}/`,
        detail: (id) => `/superadmin/program-manager/${id}/`,
        suspendAccount: (id) => `/superadmin/program-manager-suspend-account/${id}/`,
    },

    /* ================= VENDORS ================= */
    vendor: {
        list: "/vendors/vendor-list/",
        create: "/vendors/vendor/",
        tierList: "/vendors/tier-list/",
        serviceList: "/vendors/service-list/",
        update: (id) => `/vendors/vendor/${id}/`,
        detail: (id) => `/vendors/vendor/${id}/`,
        suspendVendor: (id) => `/vendors/vendor-suspend-account/${id}/`,
    },

    /* ================= TIERS ================= */
    tier: {
        list: "/vendors/tier/",
        create: "/vendors/tier/",
        update: (id) => `/vendors/tier/${id}/`,
        detail: (id) => `/vendors/tier/${id}/`,
    },

    /* ================= EXPENSES ================= */
    expense: {
        summary: "/superadmin/expenses/summary/",
        list: "/superadmin/expenses/list/",
        detail: (id) => `/superadmin/expenses/${id}/`,
        download: (id) => `/superadmin/expenses/${id}/download/`,
        update: (id) => `/superadmin/expenses/${id}/update/`,
    },

    /* ================= SERVICES ================= */
    service: {
        list: "/superadmin/service/",
        count: "/superadmin/service-count/",
        create: "/superadmin/service/",
        update: (id) => `/superadmin/services/${id}/`,
        detail: (id) => `/superadmin/services/${id}/`,
        categoryList: "/service/category-list/",
    },

    /* ================= ANALYTICS REPORTS ================= */
    analytics: {
        reportAnalytics: "/superadmin/report-analytics/",
        reportDetail: "/superadmin/report-detail/",
    },

    /* ================= ROLES & PERMISSIONS ================= */
    roles: {
        list: "/superadmin/role-permission/",
        create: "/superadmin/role-permission/",
        update: (id) => `/superadmin/role-permission/${id}/`,
        detail: (id) => `/superadmin/role-permission/${id}/`,
    },

    /* ================= SAM VIDEOS ================= */
    samVideo: {
        list: "/superadmin/sam-video/",
        create: "/superadmin/sam-video/",
        delete: (id) => `/superadmin/sam-video/${id}/`,
    },

    /* ================= Settings ================= */
    settings: {
        profile: "/superadmin/admin-profile/",
        changePassword: "/users/change-password/",
        loginActivity: "/superadmin/login-activity/",
        endOtherSessions: "/superadmin/end-other-sessions/",
    },
    auditLog: {
        list: "/superadmin/activity-logs/",
        actionList: "/superadmin/action-list/",
        resourceList: "/superadmin/resource-list/",
    },

    /* ================= Consltant Chats ================= */
    ConsltantChats: {
        List: "/consultant/chat/conversations/",
        UserChat: (userId) => `/consultant/chat/conversation/user/${userId}/`,
        Detail: (id) => `/consultant/chat/conversation/user/${id}/`,
    },

    /* ================= Consltant Assigned Users ================= */
    assignedusers: {
        list: "/consultant/assigned-users/assign-user/",
        TaskUser: '/consultant/assigned-users/task/',
        NoteUser: '/consultant/assigned-users/note/',
        Detail: (id) => `/consultant/assigned-users/assign-user/${id}`
    },

    /* ================= Consltant Service Request ================= */

    consultantService: {
        ServiceRequests: "/consultant/service/service-request/",
        Detail: (id) => `/consultant/service/service-request/${id}/`
    }


};

export default endpoints;